<template>
  <ChartContainer class="d-flex flex-column" :params.sync="params">
    <v-card-title class="flex-grow-0">
      <v-icon class="pl-3 pr-4">mdi-web</v-icon>
      Thống kê theo trình duyệt</v-card-title
    >
    <v-card-text class="flex-grow-1 full-width full-height">
      <ChartArcContainer
        :backgroundColor="backgroundColor"
        class="pa-6 px-lg-10"
        :data="dataChart"
        hideButton
        :labels="labels"
        :legend="legend"
        :loading="loading"
        :total="totalChart"
        type="percent"
      />
    </v-card-text>
    <v-card-text
      class="d-flex flex-row full-width justify-space-around flex-wrap"
    >
      <div
        v-for="item of labels"
        :key="item"
        class="device-item"
        :title="$n(current[item])"
      >
        <div class="device-name">{{ item }}</div>
        <div class="device-percent text-h6">
          {{ getPercent(current[item]) }} %
        </div>
        <GrowthPercentText :before="before[item]" :current="current[item]" />
      </div>
    </v-card-text>
  </ChartContainer>
</template>

<script>
import ChartContainer from '../ChartContainer.vue'
import ChartArcContainer from '@components/chart/ChartArcContainer.vue'
import sdk from '@service/auth-sdk'
import GrowthPercentText from '../GrowthPercentText.vue'
import { debounce, getChartColor, round } from '@utils'
export default {
  components: { ChartArcContainer, ChartContainer, GrowthPercentText },
  props: {},
  data: () => ({
    labels: [],
    loading: false,
    backgroundColor: [],
    legend: {
      display: false,
    },
    dataChart: [0, 0, 0],
    totalChart: 0,
    params: { type: '7days' },
    current: {},
    before: {},
  }),
  computed: {},
  watch: {
    params: {
      handler: debounce(function() {
        this.fetchData()
      }, 100),
      deep: true,
    },
  },
  created() {
    this.fetchData()
  },
  methods: {
    getPercent(data = 0) {
      return round((data / (this.totalChart || 1)) * 100)
    },
    async fetchData() {
      this.loading = true
      const res = await sdk.request({
        url: '/dashboard/browser/total-view',
        params: this.params,
      })
      let itemUnknown = 0
      this.totalChart = 0
      this.dataChart = []
      this.labels = []
      this.loading = false
      let data = res.data
      for (let i in data.current) {
        let item = data.current[i]
        if (!item.browser || item.browser == '0') {
          itemUnknown += item.count
        } else {
          this.dataChart.push(item.count)
          this.labels.push(item.browser)
          this.current[item.browser] = item.count
          this.backgroundColor.push(getChartColor(i))
        }
      }
      this.dataChart.push(itemUnknown)
      this.labels.push('Không xác định')
      this.backgroundColor.push(getChartColor(this.dataChart.length))
      this.current['Không xác định'] = itemUnknown

      let itemBeforeUnknown = 0
      for (let item of data.before) {
        if (!item.browser || item.browser == '0') {
          itemBeforeUnknown += item.count
        } else {
          this.before[item.browser] = item.count
        }
      }
      this.current['Không xác định'] = itemBeforeUnknown
      this.totalChart = this.dataChart.reduce((acc, cur) => acc + cur, 0)
    },
  },
}
</script>

<style scoped>
.device-item {
  text-align: center;
}
</style>
